angular
    .module("skillBuilderSaaS")
    .directive("sbStorefrontAddtocart", function () {
    return {
        restrict: "E",
        scope: {},
        bindToController: {
            productId: "=",
            pathNumber: "=",
            versionNumber: "=",
            canPurchase: "=",
            price: "=",
            currency: "=",
            data: "=",
            buttonClass: "@"
        },
        templateUrl: "app/templates/sbStorefrontAddToCartTemplate.html",
        controller: ["shoppingCartService", "$scope", function (shoppingCartService, $scope) {
                var $ctrl = this;
                $ctrl.addToCart = addToCart;
                $ctrl.removeFromCart = removeFromCart;
                this.$onInit = function () {
                    $ctrl.addClicked = false;
                    $ctrl.isInCart = shoppingCartService.isInCart($ctrl.productId);
                };
                ///////////////////////////////////////////////////////////
                function addToCart() {
                    $ctrl.addClicked = true;
                    shoppingCartService.addToCart($ctrl.productId, 1, function () {
                        $ctrl.addClicked = false;
                        $ctrl.isInCart = shoppingCartService.isInCart($ctrl.productId);
                    });
                }
                function removeFromCart() {
                    shoppingCartService.removeFromCart($ctrl.productId);
                    $ctrl.isInCart = false;
                }
                $scope.$on("cartChanged", function (_sender, productId) {
                    if (productId === $ctrl.productId) {
                        $ctrl.isInCart = shoppingCartService.isInCart($ctrl.productId);
                    }
                });
            }],
        controllerAs: "$ctrl"
    };
});
